<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.pi_inoutno}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="pi_date">
            <label class="weui-form-preview__label">{{customLabel.pi_date || "单据日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.pi_date}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pi_departmentname">
            <label class="weui-form-preview__label">{{customLabel.pi_departmentname || "部门名称"}}</label>
            <em class="weui-form-preview__value">{{form.main.pi_departmentname}}</em>
          </div>
        </custom-layout>
      </div>

      <collapse class="form-preview weui-form-preview" :title="'明细（'+form.items.length+'条）'">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{item.pd_pdno}}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="pd_ordercode">
              <label class="weui-form-preview__label">{{customLabel.pd_ordercode || "分切单号"}}</label>
              <span class="weui-form-preview__value">{{item.pd_ordercode}}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_code">
              <label class="weui-form-preview__label">{{customLabel.pr_code || "产品"}}</label>
              <span
                class="weui-form-preview__value"
              >{{item.productDTO.pr_code}} {{item.productDTO.pr_detail}}</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.productDTO.pr_brand" slot="pr_brand">
              <label class="weui-form-preview__label">{{customLabel.pr_brand || "品牌"}}</label>
              <span class="weui-form-preview__value">{{item.productDTO.pr_brand}}</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.productDTO.pr_orispeccode" slot="pr_orispeccode">
              <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
              <span class="weui-form-preview__value">{{item.productDTO.pr_orispeccode}}</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.productDTO.pr_spec" slot="pr_spec">
              <label class="weui-form-preview__label">{{customLabel.pr_spec || "规格"}}</label>
              <span class="weui-form-preview__value">{{item.productDTO.pr_spec}}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_length">
              <label class="weui-form-preview__label">{{customLabel.pr_length || "长"}}</label>
              <span class="weui-form-preview__value">{{item.productDTO.pr_length}} cm</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_width">
              <label class="weui-form-preview__label">{{customLabel.pr_width || "宽"}}</label>
              <span class="weui-form-preview__value">{{item.productDTO.pr_width}} cm</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_height">
              <label class="weui-form-preview__label">{{customLabel.pr_height || "厚"}}</label>
              <span class="weui-form-preview__value">{{item.productDTO.pr_height}} cm</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_weight">
              <label class="weui-form-preview__label">{{customLabel.pr_weight || "重"}}</label>
              <span class="weui-form-preview__value">{{item.productDTO.pr_weight}} kg</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_outqty">
              <label class="weui-form-preview__label">{{customLabel.pd_outqty || "应发数量"}}</label>
              <span class="weui-form-preview__value">{{item.pd_outqty}} {{item.productDTO.pr_unit}}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_qty_extra">
              <label class="weui-form-preview__label">{{customLabel.pd_qty_extra || "辅助数量"}}</label>
              <span class="weui-form-preview__value">{{item.pd_qty_extra}} {{item.productDTO.pr_unit_extra}}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_actoutqty">
              <label class="weui-form-preview__label">{{customLabel.pd_actoutqty || "实发数量"}}</label>
              <span class="weui-form-preview__value">{{item.pd_actoutqty}} {{item.productDTO.pr_unit}}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_batchcode">
              <label class="weui-form-preview__label">{{customLabel.pd_batchcode || "批次号"}}</label>
              <span class="weui-form-preview__value">{{item.pd_batchcode}}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_whname">
              <label class="weui-form-preview__label">{{customLabel.pd_whname || "仓库"}}</label>
              <span class="weui-form-preview__value">{{item.pd_whname}}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_price">
              <label class="weui-form-preview__label">{{customLabel.pd_price || "成本单价(元)"}}</label>
              <span class="weui-form-preview__value">{{numberFormat(item.pd_price,'#,##0.####')}}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_total">
              <label class="weui-form-preview__label">{{customLabel.pd_total || "金额(元)"}}</label>
              <span class="weui-form-preview__value">{{numberFormat(item.pd_total,'#,##0.00')}}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_remark">
              <label class="weui-form-preview__label">{{customLabel.pd_remark || "备注"}}</label>
              <span class="weui-form-preview__value">{{item.pd_remark}}</span>
            </div>
          </custom-layout>
        </div>
      </collapse>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{form.main.pi_remark}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import Collapse from "@/components/Collapse.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  components: {
    CustomLayout,
    Collapse
  },
  data() {
    return {
      baseUrl: "/api/make/prodinout",
      caller: "MakeCutPick",
      xtype: "make-makecutpick-formpanel",
    };
  }
};
</script>